module.exports = __webpack_public_path__ + "static/media/1.3_preview.0b5ac76d.png";